<template>
  <div
    :class="[
      bem.b(),
      bem.m(size),
      bem.is('disabled', disabled),
      bem.is('clearable', clearable),
      bem.is('filterable', filterable)
    ]"
    @click="handleClick"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <div :class="bem.e('wrapper')">
      <div :class="bem.e('tags')" v-if="multiple && modelValue.length">
        <span
          v-for="(tag, index) in tags"
          :key="tag.value"
          :class="bem.e('tag')"
        >
          {{ tag.label }}
          <i
            :class="bem.e('close-icon')"
            @click.stop="handleRemoveTag(tag, index)"
          ></i>
        </span>
        <input
          v-if="filterable"
          ref="inputRef"
          v-model="inputValue"
          :class="bem.e('input')"
          :placeholder="inputPlaceholder"
          @input="handleInput"
          @focus="handleFocus"
          @blur="handleBlur"
        />
      </div>
      <div v-else :class="bem.e('label')">
        {{ inputValue || placeholder }}
      </div>
      <i :class="[bem.e('icon'), iconClass]"></i>
    </div>
    <div v-show="menuVisible" :class="bem.e('menu')">
      <cms-cascader-panel
        v-model="innerValue"
        :options="options"
        :props="props"
        @change="handlePanelChange"
        @expand-change="handleExpandChange"
      ></cms-cascader-panel>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch, nextTick } from 'vue'
import { createNamespace } from '@chenms-zj/utils/create'
import {
  cascaderProps,
  cascaderEmits,
  CascaderOption,
  CascaderValue
} from './cascaders'
import CmsCascaderPanel from './cascader-panels.vue'
defineOptions({
  name: 'cms-cascaders',
  inheritAttrs: false
})
const bem = createNamespace('cascader')

const props = defineProps(cascaderProps)
const emit = defineEmits(cascaderEmits)

const inputRef = ref<HTMLInputElement | null>(null)
const menuVisible = ref(false)
const inputValue = ref('')
const innerValue = ref<CascaderValue>(props.modelValue)
const hovering = ref(false)

const tags = computed(() => {
  // 实现标签显示逻辑
})

const iconClass = computed(() => {
  // 实现图标类名逻辑
})

const inputPlaceholder = computed(() => {
  // 实现输入框占位符逻辑
})

watch(
  () => props.modelValue,
  newValue => {
    innerValue.value = newValue
  }
)

const handleClick = () => {
  if (!props.disabled) {
    menuVisible.value = !menuVisible.value
  }
}

const handleMouseEnter = () => {
  hovering.value = true
}

const handleMouseLeave = () => {
  hovering.value = false
}

const handleRemoveTag = (tag: CascaderOption, index: number) => {
  // 实现移除标签逻辑
}

const handleInput = () => {
  // 实现输入处理逻辑
}

const handleFocus = (event: FocusEvent) => {
  emit('focus', event)
}

const handleBlur = (event: FocusEvent) => {
  emit('blur', event)
}

const handlePanelChange = (value: CascaderValue) => {
  emit('update:modelValue', value)
  emit('change', value)
}

const handleExpandChange = (value: CascaderOption[]) => {
  emit('expand-change', value)
}

// 其他必要的方法和计算属性
</script>

<style scoped>
/* 组件样式可以在这里添加，或者在全局样式文件中定义 */
</style>
